import BuildTriggerLabel from "app/components/shared/BuildTriggerLabel";
import Emojify from "app/components/shared/Emojify";
import FriendlyTime from "app/components/shared/FriendlyTime";
import Icon from "app/components/shared/Icon";
import React from "react";
import { PullRequest } from "./PullRequest";

interface Props {
  createdAt: string;
  source: string;
  rebuiltFrom?: {
    url: string;
    number: number;
  };
  pipelineSchedule?: {
    url: string;
    label: string;
  };
  triggeredFrom?: {
    uuid: string;
    name: string;
    url: string;
    project: {
      name: string;
    };
    build: {
      number: number;
    };
  };
  project: {
    provider: {
      id?: string;
    };
  };
  pullRequest?: {
    url: string;
    id: string;
  };
}

export function Trigger({
  createdAt,
  source,
  rebuiltFrom,
  pipelineSchedule,
  triggeredFrom,
  ...build
}: Props) {
  let sourceLabel: React.ReactNode;

  if (rebuiltFrom) {
    sourceLabel = (
      <>
        rebuild of{" "}
        <a
          href={rebuiltFrom.url}
          className="semi-bold color-inherit hover-color-inherit"
        >
          {`#${rebuiltFrom.number}`}
        </a>
      </>
    );
  } else if (pipelineSchedule) {
    sourceLabel = (
      <>
        <span>schedule </span>
        <a
          href={pipelineSchedule.url}
          className="seni-bold color-inherit hover-color-inherit"
        >
          <Icon
            icon="schedules"
            style={{ width: 15, height: 15, marginRight: 3 }}
          />
          <Emojify text={pipelineSchedule.label} />
        </a>
      </>
    );
  } else if (triggeredFrom && triggeredFrom.url) {
    const jobName = triggeredFrom.name;

    sourceLabel = (
      <a href={triggeredFrom.url} className="color-inherit hover-color-inherit">
        <span>
          {jobName && (
            <>
              <Emojify text={jobName} className="semi-bold" />
              {" in "}
            </>
          )}
          <span className="semi-bold">{triggeredFrom.project.name}</span>{" "}
          <span className="semi-bold">#{triggeredFrom.build.number}</span>
        </span>
      </a>
    );
  } else {
    sourceLabel = triggers[source];
  }

  return (
    <>
      <span>triggered build</span>{" "}
      <FriendlyTime value={createdAt} capitalized={false} /> <span>from</span>{" "}
      {sourceLabel && <span>{sourceLabel}</span>}
      {build.pullRequest && (
        <span className="font-medium">
          {" "}
          (<PullRequest {...build} />)
        </span>
      )}
    </>
  );
}

const triggers = {
  webhook: "webhook",
  ui: "website",
  api: "API",
  trigger_job: "Pipeline",
  schedule: "Pipeline Schedule",
};
